if (!customElements.get('product-mini-card')) {
  window.renderedProductHandles = window.renderedProductHandles || new Set();
  
  customElements.define('product-mini-card', class Recommendation extends HTMLElement {
    constructor() {
      super();
    }
    async connectedCallback() {

      this.handle = this.dataset.handle;
      this.settings = {
        upsTrueSizeEnabled: true,
        upsEmptyCartTrueSizeEnabled: true,
        outOfStockThreshold: 0,
        upsOnlyTrueSizeEnabled: true,
        upsSizeSelectorEnabled: true,
        upsEmptyCartOnlyTrueSizeEnabled: true,
        upsEmptyCartSizeSelectorEnabled: true
      };

      if(this.handle) {

        this.product = await this.getProduct();
        this.render();
      }
    }
    async getProduct() {
      // Get product data
      let response = await fetch(`${window.Shopify.routes.root}products/${this.handle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      response = await response.json();
      return response;
    }
    render() {
      this.initVariables();
      this.renderProductCard(this, this.product);
    }
    initVariables() {
      const cookieUnderwearSize = getUserFittingRoomUnderwearSize();
      const cookieBandSize = getUserFittingRoomBandSize();
      const cookieCupSize = getUserFittingRoomCupSize();
      
      if(cookieUnderwearSize || (cookieBandSize && cookieCupSize)) {
        this.settings.trueSize = {
          underwearSize: cookieUnderwearSize,
          braBand: cookieBandSize,
          braCup: cookieCupSize,
          braSize: (cookieBandSize && cookieCupSize) ? `${cookieBandSize}${cookieCupSize}` : null,
        };
      } else {
        this.settings.trueSize = null;
      }
    }
    renderProductCard(template, prod) {
      const underwearSize = this.settings.trueSize?.underwearSize || null;
      const braSize = this.settings.trueSize?.braSize || null;
      const priceEl = template.querySelector('.js-recommendation-product-price');
      priceEl.textContent = toMoney(prod.variants[0].price);
      
      // Add add-to-cart button
      const sizeSelectEl = template.querySelector('.js-recommendation-product-size-select');
      const addToCartButtonEl = template.querySelector('.js-recommendation-product-add-to-cart-button');
      const productType = prod.type.toLowerCase();
      const isForm360 = prod.tags.includes('precise_sizing');
      const mappedSize = (braSize && isForm360) ? getMappedFormfitSize(braSize) : null;
      const mappedSizeAlpha = (braSize && productType !== 'bra' && prod.tags.includes('alpha')) ? getMappedAlphaSize(braSize) : null;
      let trueSize = null;
      let optCount = 0;
      let optionsEls = '<option value="" disabled selected>Select size</option>';

      sizeSelectEl && prod.variants.forEach(variant => {
        const option = variant.option2;
        if (option && (variant.inventory_policy == 'continue' || prod.tags.includes('inventory_threshold_ignore') || variant.inventory_quantity > this.settings.outOfStockThreshold)) {
          let selected = false;
          if (this.settings.upsTrueSizeEnabled || this.settings.upsEmptyCartTrueSizeEnabled) {
            if (braSize && productType === 'bra' && option === braSize) {
              selected = true;
              addToCartButtonEl.disabled = false;
              trueSize = variant.option2;
            } else if (underwearSize && (productType === 'panties' || productType === 'sleepwear') && option === underwearSize) {
              selected = true;
              addToCartButtonEl.disabled = false;
              trueSize = variant.option2;
            } else if (mappedSize && option === mappedSize) {
              selected = true;
              addToCartButtonEl.disabled = false;
              trueSize = variant.option2;
            } else if (mappedSizeAlpha && option === mappedSizeAlpha) {
              selected = true;
              addToCartButtonEl.disabled = false;
              trueSize = variant.option2;
            }
          }
          optionsEls += `<option value="${option}" ${selected ? 'selected' : ''}>${option}</option>`;
          if (optCount === 0) {
            priceEl.textContent = toMoney(variant.price);
          }
          optCount++;
        }
      });

      sizeSelectEl.insertAdjacentHTML('beforeend', optionsEls);

      if (
        (this.settings.upsTrueSizeEnabled && this.settings.upsOnlyTrueSizeEnabled && !this.settings.upsSizeSelectorEnabled && trueSize) ||
        (this.settings.upsEmptyCartTrueSizeEnabled && this.settings.upsEmptyCartOnlyTrueSizeEnabled && !this.settings.upsEmptyCartSizeSelectorEnabled && trueSize)
      ) {
        sizeSelectEl.classList.add('hidden');
        priceEl.innerHTML += ` - ${trueSize}`;
      }

      if (addToCartButtonEl && addToCartButtonEl.disabled && sizeSelectEl) {
        sizeSelectEl.addEventListener('change', () => {
          addToCartButtonEl.disabled = false;
        });
      }

      if (!optCount) {
        console.error(`Product not included in recommendation slider because it has no variant available: ${prod.title} (${prod.id})`);
        return;
      }

      if (optCount === 1 && prod.product_type?.toLowerCase() === 'kit' && sizeSelectEl && addToCartButtonEl) {
        sizeSelectEl.disabled = true;
        addToCartButtonEl.textContent = 'Go to bundle';
        addToCartButtonEl.addEventListener('click', async () => {
          location.href = url;
        });
      } else if (addToCartButtonEl) {
        addToCartButtonEl.addEventListener('click', async () => {
          window.broadcastChannel.dispatchEvent('disable-cart-upsells');
          const selectSize = sizeSelectEl.options[sizeSelectEl.selectedIndex]?.value;
          const variant = prod.variants.find(variant => variant.option2 === selectSize);

          if (!selectSize || !variant) {
            console.error('Error adding product to the cart');
            return;
          }

          const payload = {
            id: variant.id,
            quantity: 1,
            properties: {
              _tags: filterProductTags(prod.tags)
            }
          };

          const price = variant.price;
          const compareAtPrice = variant.compare_at_price;
          if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice > price) {
            payload.properties._compareAtPrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
            payload.properties._compareAtPriceCa = compareAtPrice;
          } else if (compareAtPrice && compareAtPrice > price) {
            payload.properties._compareAtPrice = compareAtPrice;
            payload.properties._compareAtPriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
          }

          if (window.cart_settings?.checkoutFinalSaleLabel && payload.properties._tags?.some(tag => tag.toLowerCase().replaceAll(/\s|-|_/g, '').includes('finalsale'))) {
            payload.properties['Final Sale'] = window.cart_settings.checkoutFinalSaleLabel;
          }

          await window.cartManager.addItem(payload);

          // Send GTM RECO data
          window.sendGTMData && window.sendGTMData({
            event: 'cart_recommendation_add_to_cart',
            source: 'cart-drawer',
            product_id: prod.id,
            product_name: prod.title,
            product_url: url,
            product_price: prod.price,
            product_size: variant.option2,
            product_color: variant.option1,
            quantity: 1
          });

          window.dispatchEvent(new CustomEvent('update-cart'));
        });
      }
    }
  })
}